import React from 'react';
import { PropTypes } from 'prop-types';

import { CarouselTypes } from '../consts';

import GeneralGallery from './GeneralGallery';
import CareerLandscape from './CareerLandscape';
import CareerPortrait from './CareerPortrait';

const GallerySlide = ({ src, alt, galleryType, width, withButtons }) => {
    switch (galleryType) {
        case CarouselTypes.GALLERY_TYPES.CAREER_LANDSCAPE:
            return <CareerLandscape {...{ src, alt, width, withButtons }} />;

        case CarouselTypes.GALLERY_TYPES.CAREER_PORTRAIT:
            return <CareerPortrait {...{ src, alt, width, withButtons }} />;

        default:
            return <GeneralGallery {...{ src, alt, width, withButtons }} />;
    }
};

GallerySlide.propTypes = {
    galleryType: PropTypes.string.isRequired,
    width: PropTypes.number.isRequired,
    src: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
    withButtons: PropTypes.bool.isRequired,
};

export default GallerySlide;
